<template>
  <div class="card modal-card height-fit-content">
    <div class="modal-card-body pd-0">
      <header class="bandeau-modal">
      </header>
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-20px">
            <h1 class="title is-size-3">
              {{ !this.viewEchWillBeNotDeleted
              ? $t('ajoutEditContrat.echeancier.popUpCreation.title')
              : $t('ajoutEditContrat.echeancier.popUpCreation.titleSuppressionEcheance')}}
            </h1>
          </div>
        </div>
      </div>
      <div class="card-content" v-if="!this.viewEchWillBeNotDeleted">
        <error-msg-component :messages="messages"
                             :error="error"
                             :champsVide="champsVide"
                             :messagesChampsVide="messagesChampsVide"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"
                             @close="error = false"/>

        <p class="has-text-weight-bold has-text-link">
          {{ $t('ajoutEditContrat.echeancier.popUpCreation.bailleurs') }}
        </p>
        <div class="columns is-multiline mgt-5px" v-if="intervenants.length > 0">
          <div class="column is-5" v-for="(intervenant, index) in intervenants" :key="index">
            <div class="card">
              <div class="card-content">
                <div class="columns mgb-0">
                  <div class="column is-1 mgv-auto">
                    <qd-checkbox v-model="intervenant.selected">
                    </qd-checkbox>
                  </div>
                  <div class="column is-11">
                    <p class="has-text-weight-bold has-text-link ellipsis">
                      {{ intervenant.tiers.nomCommercial }}
                    </p>
                    <p class="is-size-7 has-text-icon-more ellipsis">
                      {{ getLibelleAdresse(intervenant.tiers.adressePostale) }}
                    </p>
                  </div>
                </div>
                <p class="has-text-default is-size-7 ellipsis">
                  {{ $t('ajoutEditContrat.echeancier.popUpCreation.quotePart',
                  { percent : intervenant.repartition }) }}
                </p>
                <p class="has-text-default is-size-7 ellipsis">
                  {{ $t('ajoutEditContrat.echeancier.popUpCreation.modePaiementBailleur',
                  { modePaiement : getLibelleModeReglement(intervenant.modeReglementId) }) }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="mgt-10px mgb-20px">
          {{ $t('ajoutEditContrat.echeancier.popUpCreation.aucunBailleur') }}
        </div>

        <div class="columns">
          <div class="column is-4">
            <b-field :label="$t('ajoutEditContrat.echeancier.popUpCreation.debutEcheancier')"
                     class="obligatoire" custom-class="has-text-default has-text-weight-bold">
              <b-datepicker show-week-number
                            icon="calendar-today"
                            :editable="true"
                            v-model="echeancier.dateDebut"
                            position="is-bottom-right"
                            :nearby-selectable-month-days="true"/>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field :label="$t('ajoutEditContrat.echeancier.popUpCreation.finEcheancier')"
                     class="obligatoire" custom-class="has-text-default has-text-weight-bold">
              <b-datepicker show-week-number
                            icon="calendar-today"
                            :editable="true"
                            v-model="echeancier.dateFin"
                            position="is-bottom-left"
                            :nearby-selectable-month-days="true"/>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field :label="$t('ajoutEditContrat.echeancier.popUpCreation.dateFinEcheance')"
            custom-class="has-text-default has-text-weight-bold">
              <b-datepicker show-week-number
                            icon="calendar-today"
                            :editable="true"
                            v-model="echeancier.finPremiereEcheance"
                            position="is-bottom-left"
                            :nearby-selectable-month-days="true"/>
            </b-field>
          </div>
        </div>

        <div class="columns">
          <div class="column is-6">
            <b-field :label="$t('societes.produitAchat.loyer')">
              <b-autocomplete
                :value="produitAchatLibelle()"
                :data="produitsAchat"
                :loading="false"
                :open-on-focus="true"
                @select="setProduitAchat"
                @input="getProduitAchat"
                field="libelle"
                icon="magnify">
                <template slot="empty">
                  <div>
                    {{$t('general.autocomplete.noRslt')}}
                  </div>
                </template>
              </b-autocomplete>
            </b-field>
          </div>
        </div>

        <div class="columns">
          <div class="column is-narrow">
            <b-field :label="$t('ajoutEditContrat.echeancier.popUpCreation.tousLes')"
                     class="obligatoire">
              <b-input v-model="echeancier.quantitePeriodicite"></b-input>
            </b-field>
          </div>
          <div class="column is-narrow is-flex align-items-flex-end">
            <b-select expanded v-model="echeancier.periodiciteEcheancier">
              <option v-for="(periodicite) in periodiciteUnite"
                      :key="periodicite.code"
                      :value="periodicite.code">
                {{ $t(periodicite.libelle) }}
              </option>
            </b-select>
          </div>
          <div class="column is-narrow is-flex align-items-flex-end">
            <b-field :label="$t('ajoutEditContrat.echeancier.popUpCreation.montantAnnuelleHt')"
                     class="obligatoire">
              <inputCurrency :peutEtreNegatif="true"
                             v-model="echeancier.montantAnnuelHt"></inputCurrency>
            </b-field>
          </div>
          <div class="column is-narrow">
            <b-field :label="$t('ajoutEditContrat.echeancier.popUpCreation.tva')">
              <b-select expanded v-model="echeancier.pourcentageTva">
                <option v-for="tva in regimeTva"
                        :key="tva.tauxTva"
                        :value="tva.tauxTva">
                  {{ tva.tauxTva | formatPercent }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>

        <div class="columns mgt-20px">
          <div class="column is-6">
            <b-field :label="$t('ajoutEditContrat.echeancier.popUpCreation.termePaiement')">
              <b-select  v-model="echeancier.termePaiement" expanded>
                <option v-for="termePaiement in listTermePaiement"
                        :key="termePaiement.code"
                        :value="termePaiement.code">
                  {{ $t(termePaiement.libelle) }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field :label="$t('ajoutEditContrat.echeancier.popUpCreation.modePaiement')">
              <b-select expanded v-model="echeancier.modeReglementId">
                <option :value=null>
                 {{ $t('ajoutEditContrat.echeancier.popUpCreation.multiModePaiementBailleur') }}
                </option>
                <option v-for="modeReglement in modesReglement"
                        :key="modeReglement.id"
                        :value="modeReglement.id">
                  {{modeReglement.libelle}}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
        <qd-checkbox v-model="deleteEcheanceInPeriode" class="mgt-10px"
                    v-if="contrat.echeancier.length > 0">
          {{ $t('ajoutEditContrat.echeancier.popUpCreation.deleteEcheanceExistante') }}
        </qd-checkbox>
        <b-field class="mgt-20px">
          <div class="is-pulled-left boutonAction">
            <a class="button is-annuler btn-modal-annuler" @click="$parent.close()">
              {{ $t('ajoutEditContrat.echeancier.popUpCreation.actions.annuler') }}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="genererEcheancier">
              {{ $t('ajoutEditContrat.echeancier.popUpCreation.actions.genererEcheancier') }}
            </a>
          </div>
          <div class="is-pulled-left mgl-10px has-text-warning" v-if="dateIsOutsideOfPeriode">
            <p>{{ $t('ajoutEditContrat.echeancier.popUpCreation.actions.dateDifferent') }}</p>
            <p>{{ $t('ajoutEditContrat.echeancier.popUpCreation.actions.actualisation') }}</p>
          </div>
          <div class="is-pulled-left mgl-10px has-text-warning" v-if="periodiciteDiff">
            <p>{{ $t('ajoutEditContrat.echeancier.popUpCreation.actions.quantiteUniteDiff') }}</p>
            <p>{{ $t('ajoutEditContrat.echeancier.popUpCreation.actions.actualisation') }}</p>
          </div>
        </b-field>
      </div>
      <div class="card-content" v-else>
        <information-msg-component :libelleList="[{ islink: false,
          libelle: $t('ajoutEditContrat.echeancier.popUpCreation.prevInformation')}]"
                                   title="ajoutEditContrat.echeancier.popUpCreation.attention"
                                   type-message="is-warning"
                                   :hasIcon="true"
                                   :canClose="false">
        </information-msg-component>
        <v-client-table :data="allEcheancesNotDeleted" :columns="columns" :options="options">
          <div slot="bailleur" slot-scope="props" class="is-pulled-right">
            {{ props.row.tiers.nomCommercial }}
          </div>
          <div slot="produit" slot-scope="{ row }">
            {{ getProduitLocationEtDiversLibelle(row) }}
          </div>
          <div slot="montantHt" slot-scope="props" class="is-pulled-right">
            {{ props.row.montantHt | formatDevise }}
          </div>
          <div slot="montantTtc" slot-scope="props" class="is-pulled-right">
            {{ props.row.montantTtc | formatDevise }}
          </div>
          <div slot="debut" slot-scope="props" class="is-pulled-right">
            {{ props.row.modeReglement ? props.row.modeReglement.libelle : '' }}
          </div>
          <div slot="debut" slot-scope="props" class="is-pulled-right"
               :class="getColorText(props.row.debutPeriode, props.row.etat)">
            {{ props.row.debutPeriode | formatDate }}
          </div>
          <div slot="fin" slot-scope="props" class="is-pulled-right"
               :class="getColorText(props.row.finPeriode, props.row.etat)">
            {{ props.row.finPeriode | formatDate }}
          </div>
          <div slot="montantFactureTtc" slot-scope="props" class="is-pulled-right">
            {{ props.row.montantFactureTtc ? props.row.montantFactureTtc : 0 | formatDevise }}
          </div>
          <div slot="montantPaye" slot-scope="props" class="is-pulled-right">
            {{ props.row.montantPaye | formatDevise }}
          </div>
        </v-client-table>
        <b-field class="mgt-20px">
          <div class="is-pulled-left boutonAction">
            <a class="button is-annuler btn-modal-annuler"
            @click="viewEchWillBeNotDeleted = false;">
              {{ $t('ajoutEditContrat.echeancier.popUpCreation.actions.precedent') }}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="genererEcheancier">
              {{ $t('ajoutEditContrat.echeancier.popUpCreation.actions.continuer') }}
            </a>
          </div>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import { createNamespacedHelpers } from 'vuex';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { CONTRAT_ETAT_CLOS, LISTE_TERME_PAIEMENT, PERIODICITE_UNITE } from '@/configuration/baux/contrat/contratConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import inputCurrency from '@/components/general/inputCurrency';
import formatIsoDate from '@/services/general/formatIsoDate';
import { generationEcheancier } from '@/api/baux/contrat';
import validationEcheance from '@/services/baux/contrat/validationEcheance';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { AUCUN } from '@/configuration/parametrage/modeReglementConf';
import genererGuid from '@/services/general/genererGuid';
import informationMsgComponent from '@/components/general/informationMsgComponent';
import {
  NO_PAGINATION,
  NO_PER_PAGE_VALUE, RESULTS_PER_POP_UP, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import { ECHEANCE_BROUILLON, ECHEANCE_ENREGISTRER } from '@/configuration/baux/contrat/echeancier/echeancier';
import validationGeneral from '@/services/validation/validation';
import translatorEcheancier from '@/services/baux/contrat/translatorEcheancier';
import { SENS_ACHAT } from '@/configuration/devisConf';
import { getAll as getAllLocation } from '@/api/produit/produitLocation';
import { getAll as getAllDivers } from '@/api/produit/produitDivers';
import { grouperEcheanceAvecProduitAchat, separerEcheanceParProduitAchat } from '@/services/baux/commandeAchat/gestionEcheanceMultiProduit';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'p_creationEcheancier',
  props: {
    contrat: {
      type: Object,
      required: true,
    },
    echeancier: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      listTermePaiement: LISTE_TERME_PAIEMENT,
      periodiciteUnite: PERIODICITE_UNITE,
      messages: [],
      deleteEcheanceInPeriode: true,
      viewEchWillBeNotDeleted: false,
      error: false,
      messagesChampsVide: [],
      champsVide: [],
      produitsAchat: [],
      allProduitsAchat: [],
    };
  },
  components: {
    inputCurrency,
    errorMsgComponent,
    informationMsgComponent,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societesInformations: 'societesInformations',
    }),
    periodiciteDiff() {
      return this.contrat.unitePeriodicite !== this.echeancier.periodiciteEcheancier
        || this.contrat.quantitePeriodicite !== this.echeancier.quantitePeriodicite;
    },
    intervenants() {
      return this.contrat.intervenants.filter((intervenant) => {
        return intervenant.tiers && intervenant.tiers.nomCommercial;
      });
    },
    regimeTva() {
      return this.parametre(PARAMETRES_KEYS.regimeTva).filter((tva) => {
        return tva.actif || tva.tauxTva === this.echeancier.pourcentageTva;
      });
    },
    modesReglement() {
      const modesReglement = this.parametre(PARAMETRES_KEYS.modeReglement);
      return modesReglement.filter((modeReglement) => {
        return modeReglement.actionAchat !== AUCUN;
      });
    },
    dateIsOutsideOfPeriode() {
      return this.contrat.etat !== CONTRAT_ETAT_CLOS
        && (moment(this.echeancier.dateDebut).isBefore(moment(this.contrat.dateDebutEcheance))
        || moment(this.echeancier.dateFin).isAfter(moment(this.contrat.dateFinEcheance)));
    },
    allEcheancesNotDeleted() {
      const echeancesSeparees = separerEcheanceParProduitAchat(this.contrat.echeancier);
      const notDeletedEcheances = echeancesSeparees.filter(echeance => {
        if (echeance.produitLocationEtDivers.produitId !== this.echeancier.produitAchatId) {
          return true;
        }
        if (echeance.etat && echeance.etat !== ECHEANCE_ENREGISTRER && echeance.etat !== ECHEANCE_BROUILLON && moment(echeance.debutPeriode).isBetween(moment(this.echeancier.dateDebut), moment(this.echeancier.dateFin), 'day', '[]') && moment(echeance.finPeriode).isBetween(moment(this.echeancier.dateDebut), moment(this.echeancier.dateFin), 'day', '[]')) {
          return true;
        }
        return (moment(this.echeancier.dateDebut).isBetween(moment(echeance.debutPeriode), moment(echeance.finPeriode), 'day', '()')
        || moment(this.echeancier.dateFin).isBetween(moment(echeance.debutPeriode), moment(echeance.finPeriode), 'day', '()'));
      });
      return grouperEcheanceAvecProduitAchat(notDeletedEcheances);
    },
    columns() {
      return [
        'bailleur',
        'produit',
        'montantHt',
        'montantTtc',
        'debut',
        'fin',
        'montantFactureTtc',
        'montantPaye',
      ];
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          bailleur: this.$i18n.t('ajoutEditContrat.echeancier.tabEcheance.bailleur'),
          produit: this.$i18n.t('ajoutEditContrat.echeancier.tabEcheance.produit'),
          montantHt: this.$i18n.t('ajoutEditContrat.echeancier.tabEcheance.montantHt'),
          montantTtc: this.$i18n.t('ajoutEditContrat.echeancier.tabEcheance.montantTtc'),
          debut: this.$i18n.t('ajoutEditContrat.echeancier.tabEcheance.debut'),
          fin: this.$i18n.t('ajoutEditContrat.echeancier.tabEcheance.fin'),
          montantFactureTtc: this.$i18n.t('ajoutEditContrat.echeancier.tabEcheance.montantFactureAchatTtc'),
          montantPaye: this.$i18n.t('ajoutEditContrat.echeancier.tabEcheance.montantPaye'),
        },
        rowClassCallback: ((row) => {
          return row.etat && row.etat !== ECHEANCE_ENREGISTRER && row.etat !== ECHEANCE_BROUILLON ? 'background-default-table' : '';
        }),
        sortable: [],
        texts: texts,
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_POP_UP,
      };
    },
    societe() {
      return this.societesInformations.find((societe) => {
        return societe.id === this.societeActiveId;
      });
    },
    produitIdDefautLoyer() {
      return this.societe?.produitIdDefautLoyer;
    },
  },
  methods: {
    getProduitLocationEtDiversLibelle(ligne) {
      return ligne.listeProduitsLocationEtDivers.length > 1
        ? this.$t('ajoutEditContrat.echeancier.tabEcheance.multiProduit')
        : (ligne.listeProduitsLocationEtDivers[0]?.libelle ?? '');
    },
    getColorText(date, etat) {
      if (etat && etat !== ECHEANCE_ENREGISTRER && etat !== ECHEANCE_BROUILLON) return '';
      if (!moment(date).isBetween(moment(this.echeancier.dateDebut), moment(this.echeancier.dateFin), 'day', '[]')) {
        return 'has-text-danger';
      }
      return '';
    },
    produitAchatLibelle() {
      return this.allProduitsAchat
        .filter(p => p.id === this.echeancier.produitAchatId)?.[0]?.libelle;
    },
    getLibelleModeReglement(modeReglementId) {
      const modeReglementFind = this.modesReglement.find((modeReglement) => {
        return modeReglement.id === modeReglementId;
      });
      return modeReglementFind ? modeReglementFind.libelle : '';
    },
    getLibelleAdresse(adresseObject) {
      if (adresseObject === null) { return ''; }
      return adressFullStringGetter(adresseObject, false);
    },
    getLibelleTiers(tiersId) {
      const tiers = this.contrat.intervenants.find((intervenant) => {
        return intervenant.tiersId === tiersId;
      });
      return tiers ? tiers.tiers.nomCommercial : '';
    },
    getSmallestDateDebut() {
      if (this.contrat.echeancier.length === 0) return this.echeancier.dateDebut;
      let minDateDebut = moment(this.echeancier.dateDebut);
      this.contrat.echeancier.forEach((echeance) => {
        if (moment(echeance.debutPeriode).isBefore(minDateDebut)) {
          minDateDebut = moment(echeance.debutPeriode);
        }
      });
      return minDateDebut.toDate();
    },
    getHeightestDateFin() {
      if (this.contrat.echeancier.length === 0) return this.echeancier.dateFin;
      let maxDateFin = moment(this.echeancier.dateFin);
      this.contrat.echeancier.forEach((echeance) => {
        if (moment(echeance.finPeriode).isAfter(maxDateFin)) {
          maxDateFin = moment(echeance.finPeriode);
        }
      });
      return maxDateFin.toDate();
    },
    updateDateEcheanceContrat() {
      this.contrat.dateDebutEcheance = this.getSmallestDateDebut();
      this.contrat.dateFinEcheance = this.getHeightestDateFin();
    },
    async genererEcheancier() {
      if (this.deleteEcheanceInPeriode && this.contrat.echeancier.length > 0
        && !this.viewEchWillBeNotDeleted && this.allEcheancesNotDeleted.length > 0) {
        this.viewEchWillBeNotDeleted = true;
        return;
      }
      const loadingComponent = this.$buefy.loading.open();
      this.messages = [];
      this.messagesChampsVide = [];
      this.error = false;
      this.champsVide = [];
      if (this.dateIsOutsideOfPeriode) this.updateDateEcheanceContrat();
      if (this.periodiciteDiff) {
        this.contrat.unitePeriodicite = this.echeancier.periodiciteEcheancier;
        this.contrat.quantitePeriodicite = this.echeancier.quantitePeriodicite;
      }
      try {
        const echeancierCopie = cloneDeep(this.echeancier);
        this.intervenants.forEach((intervenantSelected) => {
          if (intervenantSelected.selected) {
            echeancierCopie.tiersRepartitions.push({
              tiersId: intervenantSelected.tiersId,
              aRapprocher: intervenantSelected.surFacture,
              repartition: intervenantSelected.repartition,
              modeReglementId: intervenantSelected.modeReglementId,
            });
          }
        });
        echeancierCopie.dateDebut = formatIsoDate(echeancierCopie.dateDebut);
        echeancierCopie.dateFin = formatIsoDate(echeancierCopie.dateFin);
        echeancierCopie.finPremiereEcheance = formatIsoDate(echeancierCopie.finPremiereEcheance);
        const produitAchat = this.allProduitsAchat
          .find(p => p.id === echeancierCopie.produitAchatId);
        const ligneEcheance = (await generationEcheancier(echeancierCopie)).data.result;
        ligneEcheance.forEach((ligne) => {
          ligne.key = genererGuid();
          ligne.pourcentageTva = this.echeancier.pourcentageTva;
          ligne.montantFactureTtc = 0;
          ligne.montantPaye = 0;
          ligne.tiers = {
            nomCommercial: this.getLibelleTiers(ligne.tiersId),
          };
          ligne.listeProduitsLocationEtDivers = [{
            produitId: ligne.produitAchatId,
            libelle: produitAchat?.libelle,
            typeProduit: produitAchat?.supportCommercial?.categorieVente,
          }];
        });
        if (this.deleteEcheanceInPeriode) {
          // Recuperation des échéances qui ne sont pas concernées par la génération d'écheancier
          const echeanceToKeep = this.contrat.echeancier.filter(ech => {
            if (moment(ech.finPeriode).isSameOrBefore(moment(this.echeancier.dateDebut, 'day'))
              || moment(ech.debutPeriode).isSameOrAfter(moment(this.echeancier.dateFin), 'day')) {
              return true;
            }
            return false;
          });
          this.contrat.echeancier = echeanceToKeep.concat(cloneDeep(this.allEcheancesNotDeleted));
          this.deleteEcheanceInPeriode = false;
        }
        this.$emit('echeancierGenerer', ligneEcheance);
        this.$parent.close();
        loadingComponent.close();
      } catch (e) {
        this.error = true;
        this.viewEchWillBeNotDeleted = false;
        if (e.response.data.error) {
          validationEcheance(e.response, this.messages);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translatorEcheancier);
          loadingComponent.close();

          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    async initializeProduitAchat() {
      const queryItemLocationAchat = {
        query: {
          societeId: this.societeActiveId,
          actif: null,
          sens: SENS_ACHAT,
        },
        maxResultCount: NO_PAGINATION,
        sens: SENS_ACHAT,
      };
      const produitsLocationAchat = (await getAllLocation(queryItemLocationAchat))
        .data.result.items;
      const queryItemDiversAchat = {
        query: {
          societeId: this.societeActiveId,
          sens: SENS_ACHAT,
          actif: null,
        },
        maxResultCount: NO_PAGINATION,
      };
      const produitsDiversAchat = (await getAllDivers(queryItemDiversAchat)).data.result.items;
      this.allProduitsAchat = produitsLocationAchat.concat(produitsDiversAchat);
      this.produitsAchat = this.allProduitsAchat;
      const produitAchatLocDefault = produitsLocationAchat.find(p => {
        return p.id === this.societe.produitIdDefautLoyer;
      });
      this.echeancier.produitAchatId = produitAchatLocDefault.id;
    },
    setProduitAchat(produit) {
      if (!produit) return;
      this.echeancier.produitAchatId = produit.id;
    },
    getProduitAchat(text) {
      if (!text.trim()) {
        this.produitsAchat = this.allProduitsAchat;
        return;
      }
      this.produitsAchat = this.allProduitsAchat.filter(p => p.libelle
        .toLowerCase().includes(text.toLowerCase()));
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.initializeProduitAchat();
      await this.loadParametres([PARAMETRES_KEYS.modeReglement, PARAMETRES_KEYS.regimeTva]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
